module.exports = __webpack_public_path__ + "img/icon_img_13.5d21b7e3.png";